import { useMutation, useQueryClient } from '@tanstack/react-query'
import { App as AntdApp } from 'antd'
import { useTranslation } from 'react-i18next'

import {
  organizationsTeamsCreateMutation,
  organizationsTeamsDestroyMutation,
  organizationsTeamsPartialUpdateMutation
} from 'src/api/main'

import { organizationTeamsQueryKey } from './useOrganizationTeams'

export const useTeamMutations = (workspaceId: number) => {
  const qc = useQueryClient()
  const { message } = AntdApp.useApp()
  const { t } = useTranslation()

  const invalidate = () =>
    qc.invalidateQueries({ queryKey: organizationTeamsQueryKey(workspaceId) })

  const create = useMutation({
    ...organizationsTeamsCreateMutation(),
    onSuccess: () => {
      message.success(t('organization.toasts.created'))
      void invalidate()
    },
    onError: () => message.error(t('organization.toasts.createFailed'))
  })

  const update = useMutation({
    ...organizationsTeamsPartialUpdateMutation(),
    onSuccess: () => {
      message.success(t('organization.toasts.updated'))
      void invalidate()
    },
    onError: () => message.error(t('organization.toasts.updateFailed'))
  })

  const destroy = useMutation({
    ...organizationsTeamsDestroyMutation(),
    onSuccess: () => {
      message.success(t('organization.toasts.deleted'))
      void invalidate()
    },
    onError: () => message.error(t('organization.toasts.deleteFailed'))
  })

  return { create, update, destroy }
}
